import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[color:var(--paper)]">
      <Navbar />
      {/* Content area: left margin on desktop for sidebar, top margin on mobile for topbar */}
      <div className="md:ml-[280px] pt-16 md:pt-10 flex flex-col min-h-screen">
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
      <CartDrawer />
    </div>
  );
};

export default Layout;
